import { AppView } from '../'
import { branch, memberKey } from '../constants'

module.exports = (transaction) ->

  try
    appView = await new Weaver.Query(undefined, branch).restrict('AppView').useTransaction(transaction).first()
  catch
    appView = undefined

  try
    graphView = await new Weaver.Query(undefined, branch).restrict('GraphView').useTransaction(transaction).first()
  catch
    graphView = new Weaver.Node('GraphView')
    await graphView.save({ transaction, branch, commitMessage: "GraphView type created."})

  toMigrate = await AppView.list({ authenticated: true })
  await appView.destroy(undefined, undefined, undefined, undefined, { transaction }) if appView?

  toMigrate.map((configNode) ->
    configNode.relation(memberKey).add(graphView)

    treeQuery = configNode.get('query')
    graphQuery = configNode.get('graphQuery')

    configNode.unset('graphQuery')
    configNode.set('treeQuery', treeQuery)
    configNode.set('query', graphQuery)

    configNode.save({ transaction, branch, commitMessage: "AppView -> GraphView migration." })
  )
